import React from 'react';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';


type ShowcaseConnectionDetailsPopoverContentProps = Omit<BaseConnectionDetailsPopoverContentProps, 'onLinkClick'>;

export const ShowcaseConnectionDetailsPopoverContent = (props: ShowcaseConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onCopyBtnClick } = props;
    const { type, showcaseName, showcasePagePath } = connection;

    const labels = connectionsDetailsLabels();

    return (
        <>
            <div className='connection-list__field'>{type} {labels.PAGE_PATH()}:<br />
                <TextWithCopyBtn message={showcasePagePath} handleCopyClick={onCopyBtnClick} />
            </div>
            {showcaseName && <div className='connection-list__field'>{labels.SHOWCASE_NAME()}:<br />
                <TextWithCopyBtn message={showcaseName} handleCopyClick={onCopyBtnClick} />
            </div>}
        </>
    );
};
